import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, Input, Modal } from "semantic-ui-react";
import { fpalphaAPI } from "../../../apis/FPAlphaAPI";
import { useHistory } from 'react-router-dom';
import { responseError } from "../../../helpers";
import { setSnackbar } from "../../../actions/snackbar.actions";

const RemoveCompany = ({company}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [showPassowrd, setShowPassword] = useState(false);
  const [password, setPassword] = useState("")
  const me = useSelector(state => state.me);

  const handleRemove = async () => {
    setLoader(true)
    try {
      const {data} = await fpalphaAPI.post(`/tools/company/delete`, {
        companies: [company._id],
        password_confirmation: password
      })
      dispatch(setSnackbar({message: data?.message || "The company was deleted succefully."}))

      history.push("/dashboard/companies")
    } catch (error) {
      responseError(error, undefined, "RemoveCompany.handleRemove", dispatch)

    }
    setLoader(false)
  }

  if(!me?.permissions.includes("companies:delete_company")){
    return <div></div>
  }

  return (
    <div>
      <Button color="red" onClick={() => setOpenModal(!openModal)}>
        Delete Company
      </Button>
      <Modal open={openModal} size="tiny">
        <Modal.Header>
          Are you sure delete "{company.name}" company?
        </Modal.Header>
        <Modal.Content>
          <div>
            <p>
              Please input your password to confirm this action.
            </p>
            <Form>
              <Form.Field
                control={Input}
                action={{ icon: showPassowrd ? 'eye' : 'eye slash', onClick: () => setShowPassword(!showPassowrd) }} 
                label="Password"
                type={showPassowrd ? 'text' : 'password'}
                defaultValue={password}
                fluid
                onChange={(e) => setPassword(e?.target?.value)}
              />
            </Form>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenModal(false)} disabled={loader}>
            Cancel
          </Button>
          <Button onClick={() => handleRemove()} color="red" disabled={loader || password === ""}>
            {loader ? 'Loading...' : 'Confirm'}
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default RemoveCompany;
